import React from 'react';
import { Typography, RegularButton } from 'fronton-react';
import { cx } from 'linaria';
import { useTranslation } from 'react-i18next';
import { patchUrlByLocale } from 'utils';
import {
  suggestion,
  suggestionButton,
  suggestionText,
  servicesSuggestionIcon,
  suggestionContentWrap,
  suggestionIconWrap,
  suggestionTextContentWrap,
} from './suggestion-list-item-styles';
import { SuggestionListItemServicesIcon } from './suggestion-list-item-services-icon';
import { SuggestionsGaMetaInfo } from '../../types';
import { SuggestionListItemOption } from './suggestion-list-item-option';

interface SuggestionListItemServicesPageProps {
  elementIndex: number;
  navigationIndex: number;
  isSrp: boolean;
  suggestionSelector: string;
  buttonAction: (
    id: number,
    linkToNavigate?: string,
    gaMeta?: SuggestionsGaMetaInfo,
  ) => React.HTMLAttributes<HTMLButtonElement>;
}

export const SuggestionListItemServicesPage = (props: SuggestionListItemServicesPageProps) => {
  const { isSrp, elementIndex, navigationIndex, buttonAction } = props;

  const { t } = useTranslation();

  return (
    <SuggestionListItemOption elementIndex={elementIndex} navigationIndex={navigationIndex}>
      <RegularButton
        variant="pseudo"
        tabIndex={-1}
        className={cx(suggestion, elementIndex === navigationIndex && 'active', isSrp && suggestionButton)}
        data-qa="suggestion-button"
        // eslint-disable-next-line i18next/no-literal-string
        {...buttonAction(elementIndex, '/uslugi/', {
          block: t('header.searchbar.services'),
          index: elementIndex,
          text: t('header.searchbar.projects-services'),
        })}
        href={patchUrlByLocale({ url: '/uslugi/' })}
      >
        <div className={suggestionContentWrap}>
          <div className={cx(suggestionIconWrap, servicesSuggestionIcon)}>
            <SuggestionListItemServicesIcon />
          </div>
          <div className={suggestionTextContentWrap}>
            <Typography variant="m" size="body_short" className={suggestionText} color="text-primary">
              {t('header.searchbar.projects-services')}
            </Typography>
            <Typography variant="caption" color="text-secondary">
              {t('header.searchbar.projects-services-description')}
            </Typography>
          </div>
        </div>
      </RegularButton>
    </SuggestionListItemOption>
  );
};
